'use client'

import { motion } from 'framer-motion'

type Props = {
  text: string
  delay?: number
}

export default function CinematicText({ text, delay = 0 }: Props) {
  const letters = text.split('')

  return (
    <div className="flex flex-wrap justify-center">
      {letters.map((char, i) => (
        <motion.span
          key={i}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            delay: delay + i * 0.04,
            duration: 0.5,
            ease: 'easeOut',
          }}
          className="inline-block"
        >
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      ))}
    </div>
  )
}